module.exports = __webpack_public_path__ + "static/horus_07-e4f1a7499b292d9fb363430705bed744.jpg";